import { HeadBannerResponse } from './types'
import apiFetchClient from '../client'

const getHeadBanner = async (): Promise<HeadBannerResponse> => {
    const result = await apiFetchClient<HeadBannerResponse>(
        '/head-banner/',
        {
            method: 'GET',
            skipBreadcrumb: true,
        }
    )
    return result
}

export default getHeadBanner
